import { axiosApi, createCRUD } from '@/api/axios';

export default {
  ...createCRUD('commercial_prints'),
  create(commercialPrintFormData) {
    return axiosApi.post('/commercial_prints', commercialPrintFormData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      transformRequest: [(data) => data],
    });
  },

  commercialPrints: {
    createUser(projectUserData) {
      return axiosApi.post('/commercial_print_members/', projectUserData);
    },
    deleteUser(id, listType) {
      return axiosApi.delete(`/commercial_print_members/${id}`, {
        data: {
          list_type: listType,
        },
      });
    },
  },

  history: {
    show(id, params) {
      return axiosApi.get(`/commercial_prints/${id}/history`, { params });
    },
  },

  actions: {
    show(id) {
      return axiosApi.get(`/commercial_prints/${id}/actions`);
    },
    set(id, actionData) {
      return axiosApi.patch(`/commercial_prints/${id}/actions`, actionData);
    },
  },

  files: {
    upload(id, formData) {
      return axiosApi.post(`/commercial_prints/${id}/files`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        transformRequest: [(data) => data],
      });
    },
    delete(id, fileIds) {
      return axiosApi.delete(`/commercial_prints/${id}/files`, {
        data: {
          ids: fileIds,
        },
      });
    },
    downloadFiles(fileIds) {
      return axiosApi.get('/commercial_print_files/zip', {
        params: { fileIds },
        responseType: 'blob',
      });
    },
  },
};
